import React, { Component } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import { Form } from 'formsy-react'
import { NameHeader, Close, Save, Img } from '../ModalContainer/ModalAssessment.styles'
import { Button, Select,Modal,DatePicker, TextInput } from 'advenio-components'
import moment from 'moment'

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 16px;
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  align-self: flex-end;
  flex: 1;
  margin-top: 32px;
`
const HeaderTitle = styled.div`
  flex: 1;
  height: 80px;
  border-bottom: solid 1px;
  border-bottom-color: #cccccc;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
`
const HeaderSpan = styled.span`
  font-size: 14px;
`
const CheckoutContent = styled.div`
  flex: 1;
  height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
`

const CheckoutFormContainer = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
`
const SelectDiv = styled.div`
  width: 80%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  @media (max-width: 763px) {
    width: 100%;
  }
`

const InputsRow = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 0 8px 0 8px;
`

const InputContainer = styled.div`
  flex: 1;
  margin: ${props => props.fullWidth ? '0 16px 0 16px' : '0 8px 0 8px'}
`
const ButtonsRow = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 16px 0 16px 0;
`
const SelectComponent = styled.div`
  flex: 1;
  flex-basis: 60%;
`

class EditCheckoutModal extends Component {
    state = {
        open: false,
        onClose: true,
        // onEditCheckout: 0,
        loading: false,
      }

  send = (data) => {
         this.props.onEditCheckout(
          data.checkout_time,
        )
      }
  closeModal = () => {
        //   this.props.onClose()
      }
      render() {
        const { open, onClose,loading } = this.props
        
        return (
          <Modal
            isOpened={open}
            onClose={onClose}
            headerTitle="Editar Checkout"
            statePath="activity"
            actionType="sending"
            typePrefix="ACTIVITY"
            allowOverflow
          >
              <Form onSubmit={this.send}>
                <CheckoutContent>
                  <CheckoutFormContainer>
                    <SelectDiv>
                      <SelectComponent>
                        <TextInput
                          label="Hora de salida"
                          name="checkout_time"
                          hideEmptyHelpBlock
                          validations={{
                            timeValidation: (values, time) =>
                              /^([01]\d|2[0-3]):([0-5]\d)$/.test(time) ||
                              'Ingresa una hora válida (ej. 15:45)', // eslint-disable-line comma-dangle
                          }}
                          value={moment().format('HH:mm')}
                        />
                      </SelectComponent>
                    </SelectDiv>
                  </CheckoutFormContainer>
                </CheckoutContent>
                <ButtonsRow>
                  <Button
                    onClick={onClose}
                  >
                    Cancelar
                  </Button>
                  <Button
                    primary
                    type="submit"
                    loading={loading}
                  >
                    Editar
                  </Button>
                </ButtonsRow>
              </Form>
          </Modal>
        )
      }
  // return () {
  //   const {
  //       open,
  //       onClose,
  //       onEditCheckout,
  //       loading
  //     } = this.state
    
  //       // <Modal
  //       // isOpened={open}
  //       // onClose={onClose}
  //       // headerTitle="Editar Checkout"
  //       // statePath="activity"
  //       // actionType="delete_activity"
  //       // typePrefix="CHECKOUT"
  //       // >
  //      return ( <Container>
  //                   <Form onSubmit={this.send}>
  //                   <HeaderTitle>
  //                       <Close>
  //                       <Img src="/assets/Close.svg" onClick={this.closeModal} />
  //                       </Close>
  //                       <HeaderSpan>Editar salida</HeaderSpan>
  //                       <Save>
  //                       <Button
  //                           small
  //                           style={width < 763 ? { width: '80px', height: '50px', fontSize: '13px' } : {}}
  //                           primary
  //                           type="submit"
  //                           loading={loading}
  //                       >
  //                           Confirmar
  //                       </Button>
  //                       </Save>
  //                   </HeaderTitle>
  //                   <CheckoutContent>
  //                       <CheckoutFormContainer>
  //                       <SelectDiv>
  //                           <SelectComponent>
  //                           <TextInput
  //                               label="Hora de salida"
  //                               name="checkout_time"
  //                               hideEmptyHelpBlock
  //                               validations={{
  //                               timeValidation: (values, time) =>
  //                                   /^([01]\d|2[0-3]):([0-5]\d)$/.test(time) ||
  //                                   'Ingresa una hora válida (ej. 15:45)', // eslint-disable-line comma-dangle
  //                               }}
  //                               value={moment().format('HH:mm')}
  //                           />
  //                           </SelectComponent>
  //                       </SelectDiv>
  //                       </CheckoutFormContainer>
  //                   </CheckoutContent>
  //                   </Form>
  //           {/* <span>
  //           ¿Estás seguro que deseas Editar el Chekout?
  //           </span>
  //           <ButtonsContainer>
  //           <Button
  //               ghost
  //           >
  //               Cancelar
  //           </Button>
  //           <Button
  //               primary
  //               loading={loading}
  //               onClick={onEditCheckout}
  //           >
  //               Aceptar
  //           </Button>
  //           </ButtonsContainer> */}
            
  //       </Container>
  //       // </Modal>
  //      )
  // }
}
const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(EditCheckoutModal)
)



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/EditCheckoutModal.jsx